module.exports = __webpack_public_path__ + "static/media/fvs_hamburgerKunsthalle_23.27d13114.jpg";